import styled from '@emotion/styled'
import { ChevronRight } from 'app/components/Icons'
import { styles } from 'app/theme'
import React, { memo } from 'react'

export interface Props {
  title: string
}

export const Service = memo(function Service({ title }: Props) {
  if (!title) {
    return null
  }

  return (
    <Container>
      <ChevronRight />

      {title}
    </Container>
  )
})

const Container = styled.div`
  ${styles.description}

  padding-left: 0.875rem;
  position: relative;

  svg {
    width: auto;
    height: 0.4375rem;
    fill: ${({ theme }) => theme.colors.variants.primaryDark};
    position: absolute;
    top: 0.5rem;
    left: 0;
  }
`
